import React from 'react'
import { Button, Modal, Tooltip } from 'antd'
import { QrcodeOutlined } from '@ant-design/icons'

type Props = {
  isModalVisible: boolean
  setIsModalVisible: (value: boolean) => void
  onSubmit: () => void
  qrCode?: string
  isLoading: boolean
}

export const View: React.FunctionComponent<Props> = ({
  isModalVisible,
  setIsModalVisible,
  onSubmit,
  qrCode,
  isLoading,
}) => {
  return (
    <>
      <Tooltip title="Отобразить QR код">
        <Button
          shape="circle"
          icon={<QrcodeOutlined />}
          loading={isLoading}
          onClick={onSubmit}
        />
      </Tooltip>

      <Modal
        visible={isModalVisible}
        onCancel={() => setIsModalVisible(false)}
        title={false}
        footer={false}
        style={{ textAlign: 'center' }}
      >
        {qrCode && <img alt="QR код" src={qrCode} style={{ width: 400 }} />}
      </Modal>
    </>
  )
}
